export function useVaporFileUploader(options: VaporFileUploaderOptions) {
    const axios = computed(() => {
        return window.axios;
    });

    async function sign(files: File[]) {
        let promises: Promise<any>[] = [];
        const { signUrl, bucket, expires, visibility } = options;

        files.forEach((file: File) => {
            let promise = (async () => {
                const resp = await axios.value.post(signUrl, {
                    bucket,
                    content_type: file.type,
                    expires,
                    visibility,
                });
                return resp.data;
            })();
            promises.push(promise);
        });

        const results = await Promise.allSettled(promises);

        const rejected = results.some((result) => result.status === 'rejected');
        if (rejected) {
            throw new Error('Signing :: Signing failure');
        }

        return results
            .filter((result): result is PromiseFulfilledResult<any> => result.status === 'fulfilled')
            .map((result) => result.value);
    }

    async function store(files: File[], signedUrls: any[]) {
        let promises: Promise<any>[] = [];

        signedUrls.forEach(async (signedUrlResponse: any, idx) => {
            let promise = (async () => {
                console.log('Response store is using:', signedUrlResponse);
                console.log('File Value:', signedUrls[idx]);

                const BASE_API_URL = import.meta.env.VITE_API_BASE_URL;
                const axiosInstance = axios.value.create({
                    baseURL: BASE_API_URL,
                    headers: {
                        'X-Request-With': 'XMLHttpRequest',
                        'Content-Type': files[idx].type,
                    },
                });

                await axiosInstance.put(signedUrlResponse.url, files[idx]);
                return {
                    uuid: signedUrls[idx].uuid,
                    key: signedUrls[idx].key,
                    bucket: signedUrls[idx].bucket,
                    name: files[idx].name,
                    size: files[idx].size,
                    type: files[idx].type,
                };
            })();

            promises.push(promise);
        });

        const results = await Promise.allSettled(promises);

        const rejected = results.some((result) => result.status === 'rejected');
        if (rejected) {
            throw new Error('Storing :: Upload failure');
        }

        return results.filter((result) => result.status === 'fulfilled').map((result) => result.value);
    }

    return {
        sign,
        store,
    };
}

export interface VaporFileUploaderOptions {
    signUrl: string;
    bucket: string;
    expires: string;
    visibility: string;
    scope: 'tenant' | 'central';
}
